import LayerAction from './LayerAction';
import { fetchJSON, fetchPOST, formatDate } from '../Tools';
import * as routes from './Routes';
import Pdf from './Pdf';

export default class Bar {
    protected btnToggle: HTMLElement;
    protected barInner: HTMLElement;
    protected reportStatus: IReportState;
    protected btnStartStop: HTMLButtonElement;
    protected stateContainer: HTMLElement;

    constructor() {
        const _this = this;
        if (!document.querySelectorAll('#rw-bar .hvd-inner').length) {
            return;
        }
        new Pdf();
        _this.btnToggle = document.querySelector('#rw-bar .hvd-inner').parentElement;
        _this.setup();
        this.getStatus();
    }

    private async getStatus() {
        const _this = this;
        const promise = fetchJSON(routes.RWStatus);
        promise.then( (data:IReportState) => {
            _this.reportStatus = data;
            let icon = this.btnStartStop.querySelector('i');
            if(_this.reportStatus) {
                _this.btnToggle.querySelector('i.icon-hvd').classList.add('active');
                icon.nextSibling.textContent = "Anhalten";
            } else {
                this.btnToggle.querySelector('i.icon-hvd').classList.remove('active');
                icon.nextSibling.textContent = "Start";
            }

        });
    }

    private async setup() {
        const _this = this;

        _this.barInner = document.querySelector('#rw-bar .rw-inner');
        _this.btnStartStop = _this.barInner.querySelector('button.rw-action.rw-action-start-stop');
        _this.stateContainer = _this.barInner.querySelector('.rw-report-state');
        _this.btnToggle.addEventListener('click', async (e) => {
            if (_this.reportStatus === undefined) {
                window.setTimeout(() => {
                    _this.btnToggle.dispatchEvent(new Event('click'));
                }, 400);
                return;
            }
            let icon = _this.btnStartStop.querySelector('i');

            if (_this.reportStatus) {
                icon.classList.remove('icon-play');
                icon.classList.add('icon-cancel');
                icon.nextSibling.textContent = "Anhalten";
                _this.btnToggle.querySelector('i.icon-hvd').classList.add('active');
                _this.btnStartStop.dataset.rwAction = 'cancel';
                _this.stateContainer.classList.remove('hidden');
                _this.stateContainer.querySelector('.rw-report-start').innerHTML = formatDate(
                    new Date(_this.reportStatus.startDate * 1000)
                );
                _this.stateContainer.querySelector('.rw-report-end').innerHTML = formatDate(
                    new Date(_this.reportStatus.endDate * 1000)
                );
                _this.stateContainer.querySelector('.rw-report-user').innerHTML =
                    _this.reportStatus.user.vorname + ' ' + _this.reportStatus.user.nachname;
                _this.stateContainer.querySelector('.rw-report-text').innerHTML =
                    _this.reportStatus.shortText;
                _this.stateContainer.dataset.uid = _this.reportStatus.id.toString();
                _this.barInner
                    .querySelectorAll('button.rw-action')
                    .forEach((el: HTMLButtonElement) => {
                        if (!el.classList.contains('rw-action-start-stop')) {
                            el.disabled = false;
                        }
                    });
            } else {
                icon.classList.add('icon-play');
                icon.classList.remove('icon-cancel');
                icon.nextSibling.textContent = "Starten";
                _this.btnToggle.querySelector('i.icon-hvd').classList.remove('active');
                _this.btnStartStop.dataset.rwAction = 'start';
                _this.stateContainer.classList.add('hidden');
                _this.barInner
                    .querySelectorAll('button.rw-action')
                    .forEach((el: HTMLButtonElement) => {
                        if (!el.classList.contains('rw-action-start-stop')) {
                            el.disabled = true;
                        }
                    });
            }
            _this.barInner.classList.toggle('opened');
        });

        _this.barInner.querySelectorAll('.rw-action').forEach((actionEl: HTMLElement) => {
            actionEl.addEventListener('click', (e) => {
                LayerAction.open(actionEl, async (el) => {
                    if (el.dataset.rwAction === 'cancel') {
                        await fetchPOST(routes.RWStop, {
                            id: _this.stateContainer.dataset.uid
                        });

                        _this.evUpdateReport();
                        window.tools.toast('Report', 'Der Report wurde vorzeitig gestoppt');
                        return false;
                    }
                    return true;
                });
            });
        });
        window.addEventListener('evRwSave', (data: CustomEvent) => {
            if (data.detail.toast) {
                window.tools.toast(data.detail.toast[0], data.detail.toast[1]);
            } else {
                window.tools.toast('Report', 'Der Report wurde gestartet');
                // _this.evUpdateReport(data);
            }

            // if (data.detail.bar) {
            //     _this.evUpdateReport(data);
            // } else {
            //     LayerAction.close();
            // }
            _this.evUpdateReport(data);

        });
    }

    private evStopReport() {}

    private evUpdateReport(data = null) {
        LayerAction.close();
        this.btnToggle.click();
        this.getStatus();
    }
}
